import {useRecoilValue, useSetRecoilState} from "recoil";
import { useForm } from "react-hook-form";
import { seasonFormState, ticketsFormState } from "state";
import { getLastSearch } from "../lib/utils";
import DateTime from "../models/DateTime";

const ticketsDefaultState = {
	adults: 1,
	children: 0,
	fromDateTime: new DateTime().departNow(),
	railcards: [],
	ticketType: "single",
	via: false,
	viaAvoidType: "via",
	toDateTime: null,
};

const seasonDefaultState = {
	isAdult: true,
	isChild: false,
	fromDateTime: new DateTime().departNow(),
	isFlexi: true,
	isWeekly: true,
	isMonthly: true,
	isAnnual: true,
	isCustomLength: false,
	hasRailcard: false,
	hasJCPRailcard: false,
	passengerType: "adult",
	railcards: [],
	toDateTime: null,
	via: false,
	viaAvoidType: "via"
};

const config = {
	tickets: {
		state: ticketsFormState,
		localStorageKey: 'ticketsLastSearch',
		defaultState: ticketsDefaultState
	},
	season: {
		state: seasonFormState,
		localStorageKey: 'seasonTicketsLastSearch',
		defaultState: seasonDefaultState
	},
}

const useFormController = ({ brand, tabName }) => {
	const { state, defaultState, localStorageKey, } = config[tabName];

	const form = useRecoilValue(state); // retrieve the form's state from a global state
	const setForm = useSetRecoilState(state)

	const lastSearch = getLastSearch(localStorageKey);
	const isSE = brand === 'SE';

	const methods = useForm({
		defaultValues: {
			...defaultState,
			...(isSE ? lastSearch : {}),
			...(form || {})
		}
	});

	return {
		...methods,
		form,
		setForm,
		localStorageKey
	}
}

export const useSearchFormsController = ({ brand, tabName }) => {
	const tickets = useFormController({ brand, tabName: 'tickets' });
	const season = useFormController({ brand, tabName: 'season' });

	const onStationChange = async (...props) => {
		tickets.setValue(...props);
		season.setValue(...props);

		if (tickets.getValues('stationFrom')?.name && tickets.getValues('stationTo')?.name) {
			await tickets.trigger('stationFrom');
			await tickets.trigger('stationTo');
		}

		if (season.getValues('stationFrom')?.name && season.getValues('stationTo')?.name) {
			await season.trigger('stationFrom');
			await season.trigger('stationTo');
		}
	}

	const shareStationsBetweenForms = () => {
		if (tickets.getValues('stationFrom') && !season.getValues('stationFrom')) {
			season.setValue('stationFrom', tickets.getValues('stationFrom'))
		}
		if (tickets.getValues('stationTo') && !season.getValues('stationTo')) {
			season.setValue('stationTo', tickets.getValues('stationTo'))
		}
	}

	return {
		tickets,
		season,
		onStationChange,
		shareStationsBetweenForms
	}
}
